import React, { FC, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { DialogNames } from 'src/enums'
import { useDialog } from 'src/hooks/ui'
import { ReportComponentList } from './reportComponentList'
import { CombinedReportEvents } from '../includedEvents'
import { EditIncludedEventsModal } from '../includedEvents/editIncludedEventsModal'

export const CombinedReportSettings: FC = () => {
  const [isAbleToEdit, setIsAbleToEdit] = useState<boolean>(false)
  const {
    openDialog: openDialogEditIncludedEvents,
    closeDialog: closeDialogEditIncludedEvents,
  } = useDialog(DialogNames.EditReportIncludedEvents)

  const renderActions = () => {
    if (!isAbleToEdit) {
      return (
        <Button variant="contained" onClick={openDialogEditIncludedEvents}>
          Edit
        </Button>
      )
    }

    return (
      <Button variant="contained" onClick={() => setIsAbleToEdit(false)}>
        Disable
      </Button>
    )
  }

  return (
    <Grid container direction="column" spacing={4}>
      <Grid item>
        <Grid item sx={{ pb: 2 }}>
          <Grid item>
            <Typography variant="h6">Combined report components</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <ReportComponentList />
        </Grid>
      </Grid>
      <Grid item>
        <Grid item container sx={{ pb: 2 }} spacing={2} alignItems="center">
          <Grid item>
            <Typography variant="h6">Combined report events</Typography>
          </Grid>
          <Grid item>
            {renderActions()}
          </Grid>
        </Grid>
        <Grid item>
          <CombinedReportEvents isAbleToEdit={isAbleToEdit} />
        </Grid>
      </Grid>
      <EditIncludedEventsModal
        onSubmit={() => {
          setIsAbleToEdit(true)
          closeDialogEditIncludedEvents()
        }}
        onCloseDialog={closeDialogEditIncludedEvents}
      />
    </Grid>
  )
}
